import type { ChatTheme } from './types';

export const defaultTheme: ChatTheme = {
  primary: 'oklch(0.4 0.15 225)',
  primaryForeground: '#ffffff',
  primaryTint: 'color-mix(in oklab, oklch(0.4 0.15 225) 5%, transparent)',

  background: '#ffffff',
  foreground: '#171717',

  muted: '#f3f3f5',
  mutedForeground: '#717182',
  border: '#e5e5ea',

  destructive: '#d4183d',
  warning: '#cfa500',
  warningBg: '#fffbeb',
  warningBorder: '#fee685',
  warningFg: '#973c00',
  info: '#005383',

  bubbleUser: '#00000014',
  codeBg: '#f6f8fa',

  dark: {
    primary: 'oklch(0.65 0.16 225)',
    primaryForeground: '#0c0c0e',
    primaryTint: 'color-mix(in oklab, oklch(0.65 0.16 225) 12%, transparent)',

    background: '#0c0c0e',
    foreground: '#f5f5f7',

    muted: '#27272a',
    mutedForeground: '#a1a1aa',
    border: 'oklch(1 0 0 / 12%)',

    destructive: '#f43f5e',
    warning: '#facc15',
    warningBg: 'oklch(0.32 0.06 75)',
    warningBorder: 'oklch(0.46 0.1 75)',
    warningFg: '#fde68a',
    info: '#38bdf8',

    bubbleUser: '#ffffff14',
    codeBg: '#18181b',
  },
};

export const themeCssVarMap: Record<keyof Omit<ChatTheme, 'dark'>, string> = {
  primary: '--primary',
  primaryForeground: '--primary-foreground',
  primaryTint: '--primary-tint',
  background: '--background',
  foreground: '--foreground',
  muted: '--muted',
  mutedForeground: '--muted-foreground',
  border: '--border',
  destructive: '--destructive',
  warning: '--warning',
  warningBg: '--warning-bg',
  warningBorder: '--warning-border',
  warningFg: '--warning-fg',
  info: '--info',
  bubbleUser: '--bubble-user',
  codeBg: '--code-bg',
};
